import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchDetailSection from "./SearchDetailSection";
import { configState } from "../Config";
import { styles, BoxofficeRed } from "./CsStyles";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import EventSeatIcon from "@material-ui/icons/EventSeat";
import PersonIcon from "@material-ui/icons/Person";
import Collapse from "@material-ui/core/Collapse";

import Masonry from "react-responsive-masonry";

class MovieDetail extends React.Component {
  state = {
    open: this.props.open,
    movie: this.props.movie,
    dataSource: [],
    onClose: this.props.onClose,
    expanded: false,
    images: [],
    imageLoadError: true,
    isLoading: false,
  };

  /*
   ** executeQuery - get data from API
   */
  async executeQuery(movie_id, country) {
    let nextMovie = this.props.movie;

    this.setState({
      isLoading: true,
    });

    var url = configState.apiBase + "photos?function=search";
    if (movie_id !== "") url += "&movie_id=" + movie_id;
    if (country) {
      url += "&country=" + country;
    } else {
      url += "&country=USA";
    }

    try {
      if (!nextMovie) {
        var movieDataUrl = configState.apiBase + "movies?function=search";
        if (movie_id !== "") movieDataUrl += "&movie_id=" + movie_id;
        if (country !== "" && country !== undefined)
          movieDataUrl += "&country=" + country;
        console.log("Loading: " + movieDataUrl);
        const movieDataResponse = await fetch(movieDataUrl);
        const movieDataResponseJson = await movieDataResponse.json();
        if (movieDataResponseJson.rows.length) {
          nextMovie = movieDataResponseJson.rows[0];
        }
      }

      console.log("Loading: " + url);
      const response = await fetch(url);
      const responseJson = await response.json();

      var newPoster = this.props.movie ? this.props.movie.poster : null;
      if (!newPoster) {
        newPoster = "https://www.movienewsletters.net/photos/000000H1.jpg";
      }

      this.setState({
        isLoading: false,
        images: responseJson.rows ? responseJson.rows : [],
        poster: newPoster,
        movie: nextMovie,
        open: this.props.open,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
      console.error(error);
    }
  }

  /*
   ** Got new props. So change state if they really changed.
   */
  componentDidUpdate(prevProps, prevState) {
    // If nothing important changed, we're done.
    if (
      (this.props.movie &&
        prevProps.movie.movie_id === this.props.movie.movie_id &&
        prevProps.movie.origin === this.props.movie.origin &&
        prevProps.open === this.props.open) ||
      (this.props.movie_id &&
        prevProps.movie_id === this.props.movie_id &&
        prevProps.open === this.props.open) ||
      this.state.isLoading
    ) {
      return;
    }
    if (this.props.movie_id) {
      this.executeQuery(this.props.movie_id, this.props.country);
    } else if (this.props.movie) {
      this.executeQuery(this.props.movie.movie_id, this.props.movie.origin);
    }
  }

  handleExpand = (panel) => (event, isExpanded) => {
    this.setState({ expanded: !this.state.expanded });
  };
  /*
   ** render
   */
  render() {
    const imgSrc = "https://www.movienewsletters.net/photos/";
    const defaultDisplayedImagesCount = 6;
    if (!this.state.movie) {
      return null;
    }
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.state.onClose}
          aria-labelledby="responsive-dialog-title"
          maxWidth="sm"
        >
          <div
            style={{
              backgroundColor: BoxofficeRed,
              padding: "1em",
              display: "inline-block",
            }}
          >
            <div style={{ width: "48%", float: "left" }}>
              <img
                style={{ display: "inline-block", maxWidth: "100%" }}
                src={this.state.poster}
                alt={"Movie Poster"}
                onError={(e) => {
                  if (this.state.imageLoadError) {
                    this.setState({
                      imageLoadError: false,
                    });
                    e.target.src = imgSrc + "000000H1.jpg";
                  }
                }}
              />
            </div>
            <div style={{ width: "48%", float: "right" }}>
              <h1
                style={{
                  margin: "0",
                  color: "white",
                }}
              >
                {this.state.movie.name}
              </h1>
              <p
                style={{
                  margin: "0",
                  fontSize: "1.5em",
                  color: "white",
                }}
              >
                Movie ID : {this.state.movie.movie_id}
                <br />
                {this.state.movie.imdb ? (
                  <React.Fragment>
                    IMDB : {this.state.movie.imdb} <br />
                  </React.Fragment>
                ) : null}
                {this.state.movie.parent_id ? (
                  <React.Fragment>
                    Parent : {this.state.movie.parent_id} <br />
                  </React.Fragment>
                ) : null}
                {this.state.movie.dbzid
                  ? "DBZ : " + this.state.movie.dbzid
                  : null}
              </p>
            </div>
          </div>

          <DialogContent>
            <div>
              {SearchDetailSection(
                this.state.movie,
                {
                  director: null,
                },
                "Director",
                <EventSeatIcon className={styles.toolbarIcon} />,
              )}
              {SearchDetailSection(
                this.state.movie,
                {
                  writer: null,
                },
                "Writer",
                <CreateOutlinedIcon />,
              )}
              {SearchDetailSection(
                this.state.movie,
                {
                  actor1: null,
                  actor2: null,
                  actor3: null,
                  actor4: null,
                  actor5: null,
                  actor6: null,
                  actor7: null,
                  actor8: null,
                  actor9: null,
                  actor10: null,
                },
                "Actors",
                <PersonIcon />,
              )}

              <Collapse in={this.state.images.length > 0}>
                <h2>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <CameraAltIcon />
                    &nbsp;Images
                  </div>
                </h2>

                <Masonry columnsCount={2} gutter="0.5em">
                  {this.state.images
                    .slice(0, defaultDisplayedImagesCount)
                    .map((image) => (
                      <img
                        alt=""
                        style={{ width: "100%" }}
                        src={imgSrc + image.ip_filename}
                        key={image.ip_filename}
                      />
                    ))}
                </Masonry>

                <Collapse
                  in={this.state.images.length > defaultDisplayedImagesCount}
                >
                  <Accordion
                    expanded={this.state.expanded}
                    onChange={this.handleExpand("panel1")}
                  >
                    <AccordionSummary
                      style={{ height: "1em" }}
                      expandIcon={<ExpandMoreIcon />}
                      id="panel1bh-header"
                    >
                      <h2>Click for more Images</h2>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Masonry columnsCount={2} gutter="0.5em">
                        {this.state.images
                          .slice(defaultDisplayedImagesCount)
                          .map((image) => (
                            <img
                              alt={""}
                              style={{ width: "100%" }}
                              src={imgSrc + image.ip_filename}
                              key={image.ip_filename}
                            />
                          ))}
                      </Masonry>
                    </AccordionDetails>
                  </Accordion>
                </Collapse>
                <hr />
              </Collapse>

              {SearchDetailSection(
                this.state.movie,
                {
                  release: null,
                  release2: null,
                  release3: null,
                },
                "Releases",
                <CalendarTodayIcon />,
              )}
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
} // end compoonent

export default MovieDetail;
